/**
 * The comparison picker's sources that only this device can play: a camera
 * recording and a file from the device, both blob URLs. The call hides them
 * (the other person could never see them, and the call refused them once
 * picked); the editor keeps all six. Pure, so tested.
 */
export const DEVICE_ONLY_SOURCES = ['camera', 'local'] as const;

export function listedSources<T extends { tab: string }>(all: T[], deviceSources: boolean): T[] {
  return deviceSources ? all : all.filter((s) => !(DEVICE_ONLY_SOURCES as readonly string[]).includes(s.tab));
}
